import type { ID, TextSize } from '@octopus-do/octopus-project-core'
import {
  duplicateStickyNote,
  thunkDeleteStickyNote,
} from '@store/migrationActions/thunkActions/thunkStickyNotesActions'
import { useProjectLegacyActions } from '@store/migrationActions/useProjectLegacyActions'
import type { AppState } from '@store/types'
import { useDispatch } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

export const useStickyNoteActions = (id: ID) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()
  const { changeStickyNoteColor, changeStickyNoteTextSize } =
    useProjectLegacyActions()

  const onChangeColor = (color: string) => changeStickyNoteColor({ id, color })

  const onChangeTextSize = (textSize: TextSize) =>
    changeStickyNoteTextSize({ id, textSize })

  const onDuplicate = () => dispatch(duplicateStickyNote({ id }))

  const onDelete = () => dispatch(thunkDeleteStickyNote())

  return { onChangeColor, onChangeTextSize, onDuplicate, onDelete }
}
